import scrollTo from "@common/scroll-to";

export default {
  init: () => {
    const params = new URLSearchParams(window.location.search);
    const tabId = params.get("tabid");
    const toggleId = params.get("toggleid");

    if (!tabId) return;

    const activateTabs = () => {
      const tabPanel = document.getElementById(tabId);
      if (!tabPanel) return;

      tabPanel.click();

      const tabControls = tabPanel.getAttribute("aria-controls");
      const tabContent = document.getElementById(tabControls);
      if (!tabContent) return;

      const toggleEl = toggleId && tabContent.querySelector(`[aria-controls="${toggleId}"]`);
      if (toggleEl) {
        toggleEl.click();
        scrollTo(toggleEl, 32);
      } else {
        scrollTo(tabContent, 32);
      }

      // URL cleanup
      const url = new URL(window.location.href);
      url.searchParams.delete("tabid");
      url.searchParams.delete("toggleid");
      window.history.replaceState({}, document.title, url.toString());
    };

    document.addEventListener("tabs:ready", activateTabs, { once: true });
  },
};
